module.exports = __webpack_public_path__ + "static/img/5.04a3724.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news18/5.png
// module id = HZEL
// module chunks = 1